import i18next from 'i18next';

import { fetchAllLookups } from '../../services/LookupService';

/**
 * Loads the AXI code lists into state. They are identical for every supplier
 * and never change during a session, so this runs once when the app shell
 * mounts rather than on every active supplier change.
 */
export const getLookups = () => async dispatch => {
  let response = {
    code: 0,
    msg: '',
  };

  try {
    const lookups = await fetchAllLookups();

    dispatch({
      type: 'GET_LOOKUPS',
      payload: lookups,
    });

    response.code = 200;
  } catch (err) {
    dispatch({
      type: 'LOOKUPS_ERROR',
      payload: err.message,
    });

    if (navigator.onLine) {
      response.code = 400;
      response.msg = i18next.t('alerts.errors.500');
    } else {
      response.code = 504;
      response.msg = i18next.t('alerts.errors.offlineDataNotFetched');
    }
  }

  return response;
};

export const clearLookupState = () => dispatch => {
  dispatch({ type: 'CLEAR_STATE' });
};
